module.exports = "/images/my-week.svg?b7742d1871606e93b1efdb19c3ad6acf";